<template>
  <div class="digital-page">
    <div class="digital-header" ref="headerDom">
      <RouterLink to="/" class="logo" >
        <img src="@/assets/logo.png" alt="">
      </RouterLink>
      <RouterLink to="/" class="logo-m" >
        <img src="@/assets/logo-m.png" alt="">
      </RouterLink>
      <div class="header-line"></div>
      <div class="header-title">虚拟软件专营开发</div>
    </div>
    <div class="digital-banner">
      <el-carousel height="500px">
        <el-carousel-item v-for="item in 1" :key="item" style="height: 500px;">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="digital-tab">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="parent-tab">
        <el-tab-pane label="数智WEB" name="first">
          <div class="first-level-tab-content">
            <!-- 数智WEB,4列网格布局 -->
            <DigitalTab 
              :page-info="webPage" 
              @page-total="(val) => handlePageTotal(val,'web')" 
              @reset-page="()=>resetPage('web')"
            >
              <!-- 作用域插槽接收 list -->
              <template #default="{ list }">
                <div class="tab-content grid-wrap">
                  <div v-for="item in list" :key="item.id" class="tab-item" @click="alertService">
                    <div class="item-main">
                      <img :src="item.image" alt="">
                      <div class="tab-info">
                        <h3>{{item.title}}</h3>
                        <div class="info-bottom">
                          <p>{{item.tips}}</p>
                          <div class="info-G">
                            <i class="el-icon-user"></i>
                            <p>{{item.num}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item-mask">遮盖层内容介绍</div>
                  </div>
                </div>
              </template>
            </DigitalTab>
          </div>

          <el-pagination
            small
            background
            @current-change="webPageChange"
            :current-page="webPage.current"
            :page-size="webPage.pageSize"
            layout="prev, pager, next, jumper"
            :total="webPage.total"
            prev-text="上一页"
            next-text="下一页"
            :hide-on-single-page="true"
            :pager-count="5" 
          ></el-pagination>
        </el-tab-pane>

        <el-tab-pane label="数智VR" name="second" disabled>
          <div class="first-level-tab-content">
            数智VR内容
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 云课堂,单行横向布局 -->
    <div class="digital-classroom">
      <div class="classroom-title">云课堂</div>
      <DigitalTab 
        :page-info="classPage" 
        @page-total="(val) => handlePageTotal(val,'class')" 
        @reset-page="()=>resetPage('class')"
      >
        <template #default="{ list }">
          <div class="tab-content flex-wrap">
            <div v-for="item in list" :key="item.id" class="tab-item" @click="alertService">
              <div class="item-main">
                <div class="imgBox">
                  <img :src="item.image" alt="">
                </div>
                <div class="tab-info">
                  <h3>{{item.title}}</h3>
                  <div class="info-bottom">
                    <p>{{item.tips}}</p>
                  </div>
                </div>
              </div>
              <div class="item-mask">遮盖层内容介绍</div>
            </div>
          </div>
        </template>
      </DigitalTab>

      <el-pagination
        small
        background
        @current-change="classPageChange"
        :current-page="classPage.current"
        :page-size="classPage.pageSize"
        layout="prev, pager, next, jumper"
        :total="classPage.total"
        prev-text="上一页"
        next-text="下一页"
        :hide-on-single-page="true"
        :pager-count="5"
      ></el-pagination>
    </div>

    <!-- 3D模型 -->
     <div class="digital-model">
      <div class="model-title">3D模型</div>
        <DigitalTab 
          :page-info="modelPage" 
          @page-total="(val) => handlePageTotal(val,'model')" 
          @reset-page="()=>resetPage('model')"
        >
          <template #default="{ list }">
            <div class="tab-content flex-wrap">
              <div v-for="item in list" :key="item.id" class="tab-item" @click="alertService">
                <div class="item-main">
                  <div class="imgBox">
                    <img :src="item.image" alt="">
                  </div>
                  <div class="tab-info">
                    <h3>{{item.title}}</h3>
                    <div class="info-bottom">
                      <p>{{item.tips}}</p>
                    </div>
                  </div>
                </div>
                <div class="item-mask">遮盖层内容介绍</div>
              </div>
            </div>
          </template>
        </DigitalTab>
        <el-pagination
        small
        background
        @current-change="modelPageChange"
        :current-page="modelPage.current"
        :page-size="modelPage.pageSize"
        layout="prev, pager, next, jumper"
        :total="modelPage.total"
        prev-text="上一页"
        next-text="下一页"
        :hide-on-single-page="true"
        :pager-count="5"
      ></el-pagination>
     </div>

     <!-- 页尾 -->
      <div class="digital-footer">
        <div class="footer-info">
          <div class="info-top">
            <p>
              <img src="@/assets/img/email.png" alt="">
              邮箱:sales@feitem.com.cn
            </p>
            <p>
              <img src="@/assets/img/location.png" alt="">
              地址:河南自贸试验区开封片区郑开大道八大街以西三合国际4楼
            </p>
          </div>
          <div class="info-bottom">
            COPYRIGHT2024 河南元宇宙仪器有限公司ALL RIGHTS RESERVED豫ICP备2023009490号-1
          </div>
        </div>
        <div class="footer-line"></div>
        <div class="footer-QR">
          <img src="@/assets/img/service.png" alt="">
          <p>微信客服</p>
        </div>
      </div>
  </div>
</template>

<script>
    import DigitalTab from '@/components/DigitalTab.vue';
    export default {
      name: 'DigitalPage',
      components: {
        DigitalTab
      },
      data(){
        return {
          activeName: 'first',
          webPage: {
            current: 1,
            pageSize: 8,
            total: 0,
          },
          classPage: {
            current: 1,
            pageSize: 4,
            total: 0,
          },
          modelPage: {
            current: 1,
            pageSize: 4,
            total: 0,
          },
          headerDom: null,
        }
      },
      methods: {
        handleClick(tab, event) {
          console.log(tab, event);
        },
        // 数智WEB 分页切换
        webPageChange(current){
          this.webPage.current = current;
        },
        // 云课堂 分页切换
        classPageChange(current){
          this.classPage.current = current;
        },
        // 3D模型 分页切换
        modelPageChange(current){
          this.modelPage.current = current;
        },
        handlePageTotal(total,type){
          if(type === 'web'){
            this.webPage.total = total;
          }else if(type === 'class'){
            this.classPage.total = total;
          }
          else if(type === 'model'){
            this.modelPage.total = total;
          }
        },
        resetPage(type){
          if(type === 'web'){
            this.webPage.current = 1;
          }else if(type === 'class'){
            this.classPage.current = 1;
          }
          else if(type === 'model'){
            this.modelPage.current = 1;
          }
        },
        handleScroll(){
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          // console.log(scrollTop,window.innerWidth);
          // 如果滚动超过500且屏幕宽度大于等于1200px
          if(scrollTop>=500&&window.innerWidth>=1200){
            this.headerDom.classList.add('digital-header-scroll');
          }else{
            this.headerDom.classList.remove('digital-header-scroll');
          }
        },
        alertService(){
          this.$message({
            message: '请扫描页面底部二维码，联系人工客服。',
            type: 'warning',
            duration: 5000
          });
        }
      },
      mounted() {
        this.headerDom = this.$refs.headerDom;
          window.addEventListener('scroll', this.handleScroll);
        
        // window.addEventListener('scroll', () => console.log('raw scroll event'));
      },
      beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
      }
      
    }

</script>

<style lang="scss" src="@/assets/css/digitalPage.scss" scoped></style>
<style lang="scss">
 .digital-page {
  .digital-tab {
    .parent-tab > .el-tabs__header .el-tabs__item {
      font-size: 38px !important;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .parent-tab > .el-tabs__header .el-tabs__item.is-disabled {
      color: #000 !important;
    }
    .parent-tab > .el-tabs__header .el-tabs__item::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: -10px;
      width: 60px;
      height: 2px;
      background-color: #507d33;
      transform: rotate(-45deg);
    }

    .first-level-tab-content .el-tabs .el-tabs__item {
      font-size: 14px;
      padding-left: 10px;
    }
    .first-level-tab-content .el-tabs .el-tabs__item.is-active{
      position: relative;
    }
    .first-level-tab-content .el-tabs .el-tabs__item.is-active::after{
      content: '';
      position: absolute;
      top:10px;
      left: 0;
      width: 5px;
      height: 20px;
      background-color: #507d33;
    }
    .first-level-tab-content .el-tabs .el-tabs__active-bar{
      display: none !important;
    }
  }

  .digital-classroom,.digital-model{
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs--top .el-tabs__item {
      padding-left: 10px !important;
    }
    .el-tabs__item.is-active{
      position: relative;
    }
    .el-tabs__item.is-active::after{
      content: '';
      position: absolute;
      top:10px;
      left: 0;
      width: 5px;
      height: 20px;
      background-color: #507d33;
    }
  }

  .el-pagination{
    width: 400px;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }

  /* 数智WEB网格布局 */
  .grid-wrap {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 23px;
    padding: 20px 15px;
  }

  /* 云课堂单行横向布局 */
  .flex-wrap {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 23px;
    padding: 20px 18px;
  }
  
}
@media screen and (max-width: 1200px) {
    .digital-page .digital-tab .parent-tab > .el-tabs__header .el-tabs__item  {
      font-size: 24px !important;
      margin-bottom: 0 !important;
      font-weight: bold;
    }
    .digital-page .el-pagination{
      width: 400px !important;
      margin-left: 0 !important;
      transform: none !important;
      margin-top: 20px;
    }
    .digital-page .el-tabs__nav-scroll{
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
    }
    .el-tabs__nav-scroll::-webkit-scrollbar {
    display: none;
  }
}



</style>